<script setup lang="ts">
// Mounted once in App.vue. Renders the toast queue.

import { dismiss, useToasts, type ToastAction } from '../toasts'

const { toasts } = useToasts()

async function onAction(id: number, action: ToastAction) {
  try {
    await action.run()
    dismiss(id)
  } catch {
    // Leave the toast up so the user can retry.
  }
}
</script>

<template>
  <Teleport to="body">
    <div class="toast-layer" role="region" aria-label="Notifications">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="toast"
        :class="`toast-${t.kind}`"
        :role="t.kind === 'error' ? 'alert' : 'status'"
        :aria-live="t.kind === 'error' ? 'assertive' : 'polite'"
      >
        <span class="toast-body">{{ t.message }}</span>

        <button
          v-if="t.action"
          type="button"
          class="toast-action"
          @click="onAction(t.id, t.action)"
        >{{ t.action.label }}</button>

        <button
          type="button"
          class="toast-close"
          aria-label="Dismiss"
          @click="dismiss(t.id)"
        >×</button>
      </div>
    </div>
  </Teleport>
</template>
